import { AfterViewInit, Component, EventEmitter, OnInit, ViewChild, TemplateRef } from '@angular/core';
import { Http, Response } from '@angular/http';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder, FormGroup, NgForm, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { Location } from '@angular/common';
import { DynamicDetailComponent } from '../../../dynamic-entity/components/dynamic-detail/dynamic-detail.component';
import { Observable } from 'rxjs/Observable';

import { UserService } from './user.service';
import { environment } from '../../../../environments/environment';

import { ApiService, MetadataService } from '../../../ubi-core/ubi-core.module';
import { AuthenticationService } from '../../../auth/authentication.service';

import 'rxjs/add/observable/of';
import 'rxjs/add/operator/filter';
import 'rxjs/add/operator/first';
import 'rxjs/add/operator/debounceTime';

const API_URL = environment.apiUrl;

@Component({
  selector: 'app-template',
  templateUrl: './user.component.html',
  styleUrls: ['./user.component.scss']
})
export class UserComponent extends DynamicDetailComponent implements OnInit, AfterViewInit {

  @ViewChild('formPassword') formPasswor: NgForm;

  public mainForm: FormGroup;
  private loading = false;
  private errorMessage: string = null;
  private model: any = {};
  private customers = [];
  private roles = [];
  private customerRequired = false;
  private editMode = false;

  constructor(protected baseservice: ApiService, protected metadataservice: MetadataService,
    protected router: Router, protected route: ActivatedRoute, protected location: Location,
    private fb: FormBuilder, protected toastr: ToastrService, private http: Http,
    private authenticationService: AuthenticationService) {

    super(baseservice, metadataservice, router, route, location, toastr);
  }

  ngOnInit() {
    const id = this.route.snapshot.params['id'];
    const entityFromRoute = this.route.snapshot.data['entity'];
    const navigateUrlFromRoute = this.route.snapshot.data['navigateUrl'];

    // caso existam os dois o @Input sobrepõe-se ao data do Router
    if (entityFromRoute !== null && entityFromRoute !== undefined
      && (this.entity === null || this.entity === undefined)) {
      this.entity = entityFromRoute;
    }

    // caso existam os dois o @Input sobrepõe-se ao data do Router
    if (navigateUrlFromRoute !== null && navigateUrlFromRoute !== undefined
      && (this.navigateUrl === null || this.navigateUrl === undefined)) {
      this.navigateUrl = navigateUrlFromRoute;
    }

    this.mainForm = this.fb.group({
      id: { value: null, disabled: true },
      userName: [null, Validators.required],
      firstName: [null, Validators.required],
      lastName: [null, Validators.required],
      email: [null, Validators.required],
      roles: [null, Validators.required],
      password: [null, Validators.required],
      confirmPassword: [null, Validators.required],
      customerId: null
    });

    this.authenticationService.getById(id).subscribe(user => {
      this.item = user;
      this.item.roles = this.item.roles[0];
      this.mainForm.patchValue(this.item);
      this.customerRequired = this.mainForm.value.roles === 'CUSTOMER_ROLE';
      this.editMode = true;

      this.mainForm.controls['userName'].disable();
      this.mainForm.controls['password'].setValidators(null);
      this.mainForm.controls['confirmPassword'].setValidators(null);
      this.mainForm.controls['password'].updateValueAndValidity();
      this.mainForm.controls['confirmPassword'].updateValueAndValidity();

    });

    this.item = {};

    this.getCustomers();
    this.getRoles();
  }

  ngAfterViewInit() {
    let previousValid = this.mainForm.valid;
    this.mainForm.valueChanges.subscribe(() => {
      if (this.mainForm.valid !== previousValid) {
        previousValid = this.mainForm.valid;
        this.status.canSave = previousValid;
      }

      this.customerRequired = this.mainForm.value.roles === 'CUSTOMER_ROLE';

      if (this.customerRequired) {
        this.mainForm.controls['customerId'].setValidators([Validators.required]);
        this.mainForm.controls['customerId'].updateValueAndValidity({ emitEvent: false });
      } else {
        this.mainForm.controls['customerId'].setValidators(null);
        this.mainForm.controls['customerId'].updateValueAndValidity({ emitEvent: false });
      }

    });
    this.status.canSave = previousValid;
  }

  /**
   * Obter a lista de clientes
   */
  private getCustomers() {
    // this.baseservice.setEntity('Customers');
    // this.baseservice.getPage({ 'pageSize': 100 }).subscribe(
    //   data => {
    //     this.customers = data.data;
    //   });
    this.baseservice.setEntity('Customers/GetSeaportCustomers');
    this.baseservice.getAll().subscribe(
      data => {
        this.customers = data;
      });
  }

  /**
   * Obter os perfis
   */
  private getRoles() {
    this.roles = [
      { Id: 'ADMIN_ROLE', Designation: 'Administrador' },
      { Id: 'ADVANCED_USER_ROLE', Designation: 'Utilizador Avançado' },
      { Id: 'BACKOFFICE_ROLE', Designation: 'Backoffice' },
      { Id: 'MOVEMENTS_ROLE', Designation: 'Movimentos' },
      { Id: 'OPERATOR_ROLE', Designation: 'Operador' },
      { Id: 'CUSTOMER_ROLE', Designation: 'Cliente' },
    ];

  }

  /**
   * Gravar os dados principais
   * @param event 
   */
  public save(event) {

    const formModel = this.mainForm.value;
    this.item = Object.assign(this.item, formModel);

    if (!this.customerRequired) {
      this.item.customerId = null;
    } else if (this.item.customerId === null || this.item.customerId === undefined) {
      this.toastr.warning('Verifique os campos obrigatórios.', '', { timeOut: 3000 });
      return;
    }

    if (!this.editMode) {

      this.authenticationService.create(this.item)
        .subscribe(
          data => {
            this.loading = false;
            this.router.navigateByUrl(this.navigateUrl);
            this.toastr.success('Utilizador actualizado com sucesso', '', { timeOut: 3000 });
          },
          error => {

            if (error['_body']) { // check response here.
              this.errorMessage = JSON.stringify(JSON.parse(error._body).modelState);
            } else {
              this.errorMessage = 'Ocorreu um erro a gravar.';
            }
            this.loading = false;

          });

    } else {
      this.authenticationService.update(this.item)
        .subscribe(
          data => {
            this.loading = false;
            this.router.navigateByUrl(this.navigateUrl);
            this.toastr.success('Utilizador actualizado com sucesso', '', { timeOut: 3000 });
          },
          error => {

            if (error['_body']) { // check response here.
              this.errorMessage = JSON.stringify(JSON.parse(error._body).modelState);
            } else {
              this.errorMessage = 'Ocorreu um erro a gravar.';
            }
            this.loading = false;

          });
    }
  }

  /**
   * 
   * @param event 
   */
  private onChange(event) {

    this.customerRequired = this.mainForm.value.roles === 'CUSTOMER_ROLE';

    if (this.customerRequired) {
      this.mainForm.controls['customerId'].setValidators([Validators.required]);
      this.mainForm.controls['customerId'].updateValueAndValidity();
    }

  }

  /**
   * Alteração de palavra-passe
   */
  changePassword() {
    this.loading = true;
    this.errorMessage = null;
    this.authenticationService.reset(this.item.id, this.model.newpassword)
      .subscribe(
        data => {
          this.loading = false;
          this.toastr.success('Palavra-passe alterada com sucesso', '', { timeOut: 3000 });
        },
        error => {

          if (error['_body']) { // check response here.
            this.errorMessage = JSON.stringify(JSON.parse(error._body).modelState);
          } else {
            this.errorMessage = 'Ocorreu um erro a efectuar a alteração da palavra-passe.';
          }
          this.loading = false;

        });
  }

}



// WEBPACK FOOTER //
// C:/Temp/Avemov/Avemov-Angular/src/app/base/config/users/user.component.ts